import React from "react";
import classnames from "classnames";
import "./Button.scss";

const Button: React.FunctionComponent<any> = ({ children, red, white, black, noReact, className, ...props }) => {
  return <button {...props} className={classnames("Button", { red, white, black, "no-react": noReact }, className)}>{children}</button>;
};

export default Button;
